import { Media } from 'v2/shared/components/media/media'
import type { RFileUploadResponse } from 'v2/types/api/auth'

interface MessageImagesProps {
  files: Array<RFileUploadResponse>
}

export const MessageImages = ({ files }: MessageImagesProps) => {
  if (!files || files.length === 0) return null

  return (
    <div className="flex min-w-0 max-w-full flex-wrap gap-2 mt-2 font-inter text-foreground [&>div]:min-w-0">
      {files.map((file) => (
        <Media
          key={file.file_id}
          file={file}
          multipleMedia={files.length > 1}
          hideMessage
          onPreview={() => {}}
        />
      ))}
    </div>
  )
}
